// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import axios from 'utils/axios';
import { dispatch } from '../index';

// ----------------------------------------------------------------------

const initialState = {
    modeofpayList: [],
    selectedModeofpay: null,
    message: null,
    status: false,
    error: ''
};

const slice = createSlice({
    name: 'modeofpay',
    initialState,
    reducers: {
        hasError(state, action) {
            state.error = action.payload;
        },
        setModeofpays(state, action) {
            state.modeofpayList = action.payload;
        },
        setSelectedModeofpay(state, action) {
            state.selectedModeofpay = action.payload;
        },
        setModeofpay(state, action) {
            const data = action.payload;
            const rowIndex = state.modeofpayList.findIndex((item) => item.id === data.id);
            if (rowIndex) {
                state.modeofpayList[rowIndex] = data;
            }
        }
    }
});

// Reducer
export default slice.reducer;
export const { setSelectedModeofpay } = slice.actions;
// ----------------------------------------------------------------------

export function getModeofpays(data) {
    return async () => {
        try {
            const response = await axios.post('/modeofpay/list', data);
            if (response.data.status) {
                dispatch(slice.actions.setModeofpays(response.data.data));
            } else {
                dispatch(slice.actions.hasError(response.data.message));
            }
        } catch (error) {
            dispatch(slice.actions.hasError(error.message));
        }
    };
}
export function getModeofpay(id) {
    return async () => {
        try {
            const response = await axios.post('/modeofpay/details', { id });
            if (response.data.status) {
                dispatch(slice.actions.setModeofpay(response.data.data));
            } else {
                dispatch(slice.actions.hasError(response.data.message));
            }
        } catch (error) {
            console.log(error);
        }
    };
}
export function saveModeofpay(data) {
    return async function () {
        const response = await axios.post('modeofpay/save', data);
        return response;
    };
}

export function updateModeofpay(data) {
    return async function () {
        const response = await axios.post('modeofpay/update', data);
        return response;
    };
}

export function deleteModeofpay(data) {
    return async function () {
        const response = await axios.post('modeofpay/delete', data);
        return response;
    };
}
